export default import.meta.ROLLDOWN_FILE_URL_ktSXZAIihv_0EA_iN3QxeA